export default {
  ridership: {
    title: 'Yolculuk Panosu',
    ridershipByRoute: 'Rotaya Göre Yolculuk',
    ridershipByStop: 'Durağa Göre Yolculuk',
    byRun: 'Sefere Göre',
    byDayOfWeek: 'Haftanın Gününe Göre',
    byDate: 'Tarihe Göre',
    byTimeOfDay: 'Saate Göre',
    byWeekday: 'Haftanın Gününe Göre',
    byFirstStopDeparture: 'İlk Durak Kalkışına Göre',
    byLastStopArrival: 'Son Durak Varışına Göre',
    allTripsArriving: 'Arasında varan tüm seferler',
    allTripsDeparting: 'Arasında kalkan tüm seferler',
    allTripsArrivingDeparting: 'Arasında varan/kalkan tüm seferler',
    allDepartures: 'Arasındaki tüm kalkışlar',
    allArrivals: 'Arasındaki tüm varışlar',
    loadFactor: 'Doluluk Oranı',
    totalRidership: 'Toplam Yolculuk',
    vehicleOccupancy: 'Araç Doluluk',
    total: 'Toplam',
    allRoutes: 'Tüm Rotalar',
    moreRoutes: '+{0} rota daha',
    noRoutesInRouteGroups: 'Seçili rota gruplarında rota yok',
    allStops: 'Tüm Duraklar',
    selectStop: 'Durak Seç',
    allDirections: 'Tümü',
    inbound: 'Geliş',
    outbound: 'Gidiş',
    loop: 'Döngü',
    direction: 'Yön',
    route: 'Rota',
    stop: 'Durak',
    riders: 'Yolcular',
    numRiders: '# Yolcu',
    totalOn: 'Binen',
    totalOff: 'İnen',
    sum: 'Toplam',
    on: 'Binen',
    off: 'İnen',
    sortBy: 'Sırala',
    ascending: 'artan',
    descending: 'azalan',
    legendForRouteColors: 'Rota Renkleri Açıklaması',
    noData: 'Seçilen filtreler için veri bulunamadı',
    loading: 'Yükleniyor...',
    exportExcel: 'Excel İndir',
    timeOfDay: 'Günün Saati',
    dayOfWeek: 'Haftanın Günü',
    date: 'Tarih',
    scheduled: 'Planlanan',
    actual: 'Gerçekleşen',
    period: 'Dönem',
    referenceTime: 'Referans Zamanı',
    fromTime: 'Başlangıç',
    toTime: 'Bitiş',
    viewMore: '{count} durak daha göster',
    viewLess: 'Daha az göster',
    interval: 'Aralık',
    interval15Min: '15 dk',
    interval30Min: '30 dk',
    interval1Hour: '1 sa',
    departureTimeGroupedBy: 'Kalkış Saati ({interval} aralıklarla gruplanmış)',
    arrivalTimeGroupedBy: 'Varış Saati ({interval} aralıklarla gruplanmış)',
    intervalSuffix15Min: '15 dk',
    intervalSuffix30Min: '30 dk',
    intervalSuffix1Hour: '1 saatlik',
    departureTimeExact: 'Kalkış saati (Tam kalkış saatleri gösteriliyor)',
    arrivalTimeExact: 'Varış saati (Tam varış saatleri gösteriliyor)',
    dayPlural: '{day} günleri',
    dep: 'Klk.',
    arr: 'Vrş.',
    departures: 'kalkış',
    arrivals: 'varış',
  },
};
